input.textInput {
  box-sizing: border-box;
  width: 307px;
  height: 32px;
  margin: 0;
  border: 1px solid var(--theme-primary-border);
  padding: var(--spacer-1) var(--spacer-2);
  font-size: var(--font-size-050);
  color: var(--theme-primary-text);
  border-radius: var(--Common--border-radius);
}

.selectro {
  :global(.selectro-trigger) {
    width: 307px;
    height: 32px;
  }
}
